import React, { useState, useEffect } from 'react';
import CircularProgress from '@mui/material/CircularProgress';

// Components
import Button from './components/Button';
import DisplayTime from './components/DisplayTime';
import DisplayWeather from './components/DisplayWeather';
import CourseWorkUpcoming from './components/CourseWorkUpcoming';
import ActiveClasses from './components/ActiveClasses';
import DisplayBellSchedule from './components/DisplayBellSchedule';
import DisplayCanvasEvents from './components/DisplayCanvasEvents';
import DisplayPeriodTimer from './components/DisplayPeriodTimer';
import DisplaySchedule from "./components/DisplaySchedule";
import User from "./components/User";

// Custom Hooks
import { useAuthContext } from './context/AuthContext';
import { useSchedule } from './hooks/useSchedule';
import { useCanvas } from './hooks/useCanvas';

// Utils
import { fetchWeather } from './utils/weatherUtils';
import { recentClass } from './utils/dateUtils';
import {useClassroomContext} from "./context/ClassroomContext";

const Home = () => {
    const { googleUser, login, logout } = useAuthContext();
    const schedule = useSchedule();
    const { canvasEvents, canvasUrl, setCanvasUrl, showCanvasInput, handleFetchCanvasEvents, handleRefresh } = useCanvas(googleUser);
    const { classes, isLoadingClasses, refreshClasswork } = useClassroomContext();
    const organization = JSON.parse(localStorage.getItem("classOrganization"));

    const [weather, setWeather] = useState(null);
    const [switchOn, setSwitchOn] = useState(true);
    const [currentTime, setCurrentTime] = useState(new Date());

    // Update time every minute
    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 60000);
        return () => clearInterval(timer);
    }, []);

    // Fetch weather on mount
    useEffect(() => {
        const loadWeather = async () => {
            const data = await fetchWeather();
            if (data) {
                setWeather(data);
            }
        };
        loadWeather();
    }, []);

    return (
        <div className="Home">
            <div className="header-container">
                <h1>MVHS Student Planner</h1>
                {googleUser && (
                    <div className="header-user">
                        <User user={googleUser.name} email={googleUser.email} icon={googleUser.picture}/>
                    </div>
                )}
            </div>

            {!googleUser ? (
                <Button onClick={login}>Sign in with Google</Button>
            ) : (
                <>
                    <Button onClick={logout}>Log out</Button>
                    <Button onClick={refreshClasswork}>Refresh Assignments</Button>
                </>
            )}
        <DisplayTime/>

            {schedule && schedule.scheduleType && (
                <DisplayPeriodTimer
                    scheduleType={schedule.scheduleType}
                    classes={classes}
                    organization={organization}
                />
            )}
            {schedule && (
                <DisplaySchedule scheduleType={schedule.scheduleType} />
            )}
            <div className = "main-layout">
                <div className = "main-column">




                    {schedule && schedule.scheduleType && (
                        <DisplayBellSchedule
                            scheduleType={schedule.scheduleType}
                            classes={classes}
                            organization={organization}
                        />
                    )}
                    {googleUser && (
                        <DisplayCanvasEvents
                            events={canvasEvents}
                            canvasUrl={canvasUrl}
                            onRefresh={handleRefresh}
                            showInput={showCanvasInput}
                            onLoadEvents={handleFetchCanvasEvents}
                            setCanvasUrl={setCanvasUrl}
                        />
                    )}

          
                    {googleUser && !isLoadingClasses && (
                        <ActiveClasses
                            googleUser={googleUser}
                            classes={classes}
                            recentClass={recentClass}
                        />
                    )}

                </div>
                <div className="side-column">
                    {googleUser && isLoadingClasses && (
                        <div className="loading-container">
                            <CircularProgress color="secondary" />
                            <p>Loading classes...</p>
                        </div>
                    )}

                    {googleUser && (
                        <CourseWorkUpcoming
                            classes={classes}
                            switchOn={switchOn}
                            setSwitchOn={setSwitchOn}
                            currentTime={currentTime}
                            recentClass={recentClass}
                            userEmail={googleUser.email}
                        />
                    )}

                    
                </div>
            </div>

            
            {weather && (
                <div>
                    <h1>Weather at MVHS now</h1>
                    <DisplayWeather
                        temp={weather.hourly.temperature_2m[new Date().getHours()]}
                        rainChance={weather.hourly.precipitation_probability[new Date().getHours()]}
                        code={weather.hourly.weather_code[new Date().getHours()]}
                        isDay={weather.hourly.is_day[new Date().getHours()] === 1}
                    />
                </div>
            )}
        </div>
    );
}

export default Home;